module.exports = __webpack_public_path__ + "static/Local_Business-106e1df0a4265f9d8ef189126b1949d2.webm";